import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';

import { Button } from '@/components/ui';
import styles from './NotFound.module.css';

export function NotFound() {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Pagina No Encontrada — Ratio';
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h1>404</h1>
                <h2>Pagina no encontrada</h2>
                <p>La pagina que buscas no existe.</p>
                <Button
                    variant="primary"
                    onClick={() => navigate(ROUTES.feed)}
                >
                    Volver al inicio
                </Button>
            </div>
        </div>
    );
}

